/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBracketsOff = createReactComponent("brackets-off", "IconBracketsOff", [
  ["path", { d: "M5 5v15h3", key: "svg-0" }],
  ["path", { d: "M16 4h3v11m0 4v1h-3", key: "svg-1" }],
  ["path", { d: "M3 3l18 18", key: "svg-2" }]
]);

export { IconBracketsOff as default };
//# sourceMappingURL=IconBracketsOff.js.map
